/**
* Growl message event
*/
export class GrowlMessageEvent {
  constructor(public security: string, public summary: string, public detail: string) {

  }
}
